import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { TaApiServiceLogin, TaUserCredential } from 'src/app/service/api/TaApiServiceLogin';
import { MatDialog } from '@angular/material/dialog';
import { TAUtility } from 'src/app/theoalex/theoalex';
import { iTaObserverComponent } from 'src/app/theoalex/taObserverComponent';
import { Subscription } from 'rxjs';
import { TaUniversalHubSubject } from 'src/app/service/web/universal-hub.service';
import { TaApiServiceShoppingCart } from 'src/app/service/api/TaApiServiceShoppingCart';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy, iTaObserverComponent {

  userAuthenticCheckedEventSubscriber: Subscription;
  loginUser: TaUserCredential;
  isLogged: boolean = false;
  shoppingCartChangedSubscription: Subscription;
  shoppingCartCount: string = "0";
  isUserCredentialProviderAcquiring = false;
  queryString: string = "";
  uRLReturn: string = "";
  constructor(private loginService: TaApiServiceLogin, private dialog: MatDialog, private shoppingCartService: TaApiServiceShoppingCart,
    public router: Router,) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.queryString = event.url;
      }
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isUserCredentialProviderAcquiring = false;
      this.subscriberEvents();
    })
  }

  ngOnDestroy(): void {
    this.unsubscriberEvents();
  }

  subscriberEvents(): void {
    this.userAuthenticCheckedEventSubscriber = TaUniversalHubSubject.userCredentialSubjectData.subscribe(credential => {
      if (credential?.UserName) {
        this.refreshShoppingCartCount();
      }
      if (!credential?.UserName) {
        const id = localStorage.getItem("UserID");
        const isLogin = localStorage.getItem("IsLogin");
        if (isLogin === "1") {
          if (id && id !== null && id !== undefined) {
            if (id !== undefined) {
              this.loginService.loginByUserId(id).subscribe(res => {
              });
            }
          }
        }
      }
      this.loginUser = credential;
      localStorage.setItem('UserName', this.loginUser?.UserName);
      localStorage.setItem('UserID', this.loginUser?.UserId);
      localStorage.setItem('FirstName', this.loginUser?.FirstName);
      localStorage.setItem('UserRole', this.loginUser?.UserType);
      localStorage.setItem('Region', this.loginUser?.Region);
    });

    this.shoppingCartChangedSubscription = TaUniversalHubSubject.shoppingCartChanged.subscribe(cartItems => {
      this.refreshShoppingCartCount();
    })

    TaUniversalHubSubject.userCredentialProviderAcquiringSubject.subscribe(isAcquiring => {
      this.isUserCredentialProviderAcquiring = isAcquiring;
    })
  }

  unsubscriberEvents(): void {
    TAUtility.unsubscribe(this.userAuthenticCheckedEventSubscriber, this.shoppingCartChangedSubscription);
  }

  private refreshShoppingCartCount() {
    this.shoppingCartService.getClientShoppingCart(() => {
      this.shoppingCartCount = this.shoppingCartService.shoppingCart ? this.shoppingCartService.shoppingCart.Count : "0";
      localStorage.setItem('Cart', this.shoppingCartCount);
    })
  }

  logout() {
    this.loginService.logout(true);
    localStorage.setItem("IsLogin", "0");
    if (this.queryString.includes("index")) {
      this.uRLReturn = environment.appWebUrl + "index.html";
    }
    else {
      if (this.queryString.includes("about")) {
        this.uRLReturn = environment.appWebUrl + "about.html";
      }
      if (this.queryString.includes("contact")) {
        this.uRLReturn = environment.appWebUrl + "contact.html";
      }
      if (this.queryString.includes("site-map")) {
        this.uRLReturn = environment.appWebUrl + "site-map.html";
      }
      if (this.queryString.includes("dealer-locator")) {
        this.uRLReturn = environment.appWebUrl + "dealer-locator.html";
      }
      if (this.uRLReturn.length == 0) {
        this.queryString = this.queryString.replace("/checklogout/", "");
        if (this.queryString.split("_")[1]) {
          let parameter01 = this.queryString.split("_")[0];
          let parameter02 = this.queryString.split("_")[1];
          this.uRLReturn = environment.appWebUrl + parameter01 + "/" + parameter02 + ".html";
        }
      }
    }
    localStorage.setItem('UserName', '');
    localStorage.setItem('FirstName', '');
    localStorage.setItem('Region', '');
    // window.location.href = this.uRLReturn;
    // window.location.reload();
  }
}
